import gsap from 'gsap'
import input from '@/scripts/canvas/Input'
import audioManager from '@/scripts/audio/audioManager'
import { Assets } from 'pixi.js'
import Analytics, { ACTION_SECRET_OPEN } from '@/scripts/analytics'
import { playHiddenPlaceReveal } from '@/scripts/audio/soundController'

export const openedHiddenPlaces = new Set<string>()
let boxEl: HTMLDivElement | null = null
let imgEl: HTMLImageElement | null = null
let isOpen = false

function ensureDom(): boolean {
  if (!boxEl) boxEl = document.querySelector<HTMLDivElement>('.hidden-place-box')
  if (!imgEl) imgEl = boxEl?.querySelector<HTMLImageElement>('.hidden-place-image') ?? null
  return !!boxEl && !!imgEl
}

export function openHiddenPlaceBox(id: string): void {
  if (!ensureDom() || !boxEl || !imgEl) return
  if (isOpen) return

  playHiddenPlaceReveal(id)

  Analytics.sendCustomEvent(ACTION_SECRET_OPEN, id)
  const fakeCanvas = document.querySelector('.fake-canvas')
  fakeCanvas?.classList.add('overlay')

  input.lock()

  audioManager.stopItemSfx()
  audioManager.stopHiddenPlaceSfx()
  audioManager.playHiddenPlaceSfx(id)
  audioManager.fadeMusicVolumeDown()
  isOpen = true

  imgEl.src = ''
  const texture = Assets.get(`sm_${id}`)
  const resource = texture.baseTexture.resource as { url?: string; src?: string }
  const src = resource.url ?? resource.src ?? ''
  imgEl.src = src

  boxEl.classList.remove('invisible')
  boxEl.addEventListener('click', () => closeHiddenPlaceBox())

  // Reset animation start state
  gsap.set(boxEl, { opacity: 0, scale: 0.5, transformOrigin: '50% 50%' })

  // Next frame animation to avoid "first click no scale" bug
  requestAnimationFrame(() => {
    gsap.to(boxEl, { duration: 0.4, opacity: 1, ease: 'sine.out' })
    gsap.to(boxEl, { duration: 0.4, scale: 1, ease: 'back.out(1.5)' })
  })
}

export function closeHiddenPlaceBox(): void {
  if (!ensureDom() || !boxEl) return
  if (!isOpen) return
  isOpen = false

  audioManager.stopHiddenPlaceSfx()
  audioManager.fadeMusicVolumeUp()

  gsap.to(boxEl, {
    duration: 0.3,
    opacity: 0,
    scale: 0.4,
    ease: 'sine.in',
    onComplete: () => {
      boxEl?.classList.add('invisible')
      const fakeCanvas = document.querySelector('.fake-canvas')
      fakeCanvas?.classList.remove('overlay')
      input.unlock()
      input.start()
    },
  })
}
